import { useDispatch, useSelector } from "react-redux";
import { getImpersonatedBy, getUserName } from "store/userSlice";
import { doLogout } from "helpers/logout";
import { useTranslation } from "translation/useTranslation";
import Banner from "components/ui/Banner";
import Button from "components/ui/Button";

export default function ImpersonationBanner({ className = "" }) {
  const dispatch = useDispatch();
  const impersonatedBy = useSelector(getImpersonatedBy);
  const userName = useSelector(getUserName);
  const { editableTranslate } = useTranslation();

  if (!impersonatedBy) return null;

  return (
    <Banner intent="warning" className={className} data-testid="impersonation-banner">
      <div className="d-flex align-items-center justify-content-between">
        <span>{editableTranslate('global.impersonation.banner', 'Sie sind als {name} angemeldet (Impersonation durch {admin}).', { name: userName, admin: impersonatedBy.admin_name })}</span>
        <Button variant="secondary" size="sm" className="ml-2" onClick={() => doLogout(dispatch)} data-testid="impersonation-banner-end">{editableTranslate('global.impersonation.end', 'Ende')}</Button>
      </div>
    </Banner>
  );
}
